<template>
  <g>
    <g clip-path="url(#clip0_15_889)">
      <path
        d="M19 0.000244141H5C4.45 0.000244141 4 0.450244 4 1.00024C4 1.55024 4.45 2.00024 5 2.00024H19C19.55 2.00024 20 1.55024 20 1.00024C20 0.450244 19.55 0.000244141 19 0.000244141ZM5 24.0002H19C19.55 24.0002 20 23.5502 20 23.0002C20 22.4502 19.55 22.0002 19 22.0002H5C4.45 22.0002 4 22.4502 4 23.0002C4 23.5502 4.45 24.0002 5 24.0002ZM20 4.00024H4C2.9 4.00024 2 4.90024 2 6.00024V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00024C22 4.90024 21.1 4.00024 20 4.00024ZM12 6.75024C13.24 6.75024 14.25 7.76024 14.25 9.00024C14.25 10.2402 13.24 11.2502 12 11.2502C10.76 11.2502 9.75 10.2402 9.75 9.00024C9.75 7.76024 10.76 6.75024 12 6.75024ZM17 17.0002H7V15.5002C7 13.8302 10.33 13.0002 12 13.0002C13.67 13.0002 17 13.8302 17 15.5002V17.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_889">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
